import useStatusIcon from '@/DesignSystem/hooks/useStatusIcon';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';

const LineupPlayerAlternatives = memo(({ player, players, fontSize }) => {
    if (!player?.alternatives?.length) {
        return null;
    }

    return player.alternatives?.map((alternative, index) => {
        const alternativeId = alternative.information?.id ?? alternative.id ?? alternative;
        const playerFound = players?.find(
            (p) => p.id === alternativeId || p.information?.id === alternativeId
        );

        if (!playerFound) {
            return null;
        }

        const statusIcon = useStatusIcon({
            status: playerFound?.generalStatus?.status ?? playerFound?.status,
            statusLevel: playerFound?.generalStatus?.statusLevel ?? playerFound?.statusLevel,
            width: 10,
            height: 10,
            skipIfNotOk: true,
        });

        const name = playerFound?.information?.name ?? playerFound?.name;

        const bottom = (index + 1) * 15 * -1;

        return (
            <Box
                fontSize={fontSize}
                sx={{
                    position: 'absolute',
                    bottom: bottom,
                    textAlign: 'center',
                }}
                key={`alternative-${index}-${playerFound.id}`}
            >
                <Typography
                    component={'span'}
                    fontSize={12}
                    sx={{ position: 'absolute', left: '-12px', bottom: 1 }}
                >
                    {statusIcon}
                </Typography>
                <Typography
                    fontSize={fontSize}
                    sx={{
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        textAlign: 'center',
                        fontSize: { xs: 10, sm: 12 },
                        color: '#ccc',
                    }}
                >
                    {name}
                </Typography>
            </Box>
        );
    });
});

LineupPlayerAlternatives.displayName = 'LineupPlayerAlternatives';

export default LineupPlayerAlternatives;
